module.exports = __webpack_public_path__ + "images/marketing/ininbox-integration.png";